import React from 'react';
import Sign2Text from '../components/sign2text';

const SignToTextPage = () => {
  return <Sign2Text />;
};

export default SignToTextPage; 